import React from 'react';
import { Card, Col, Form, Button } from 'react-bootstrap';

import style from "../genrator.module.css";

interface Props {
    handleNewTagBtnClick: any;
    setDsp:any,
    setType:any,
    setEnv:any,
    setExchange:any,
    setAddOns:any,
    dsp:any,
    type:any,
    env:any,
    exchange:any
    addOns:any
}

const TopFilter =({ handleNewTagBtnClick,setDsp,setType,setEnv,setExchange,setAddOns,dsp,type,env,exchange,addOns }: Props)=>{
    const dspList = ["BeesWax", "MyDSP", "ESKIMI"]; 

    return (
      <>
        <Card.Header style={{backgroundColor:'#fff',borderBottom:'0',marginTop:'20px',marginBottom:'20px',display:'flex',alignItems:'center',marginRight:'0'}}>
              <Col lg={6} style={{display:'flex',alignItems:'center',gap:'15px'}}>
                  <Col lg={1} style={{width:'max-content'}} className="color-4b4b5a">Filter By:</Col>
                  <Col>
                    <Form.Group>
                        <Form.Select name="dsp" className="fsz-875rem" onChange={e=>setDsp(e.target.value)} defaultValue={dsp}  >
                            <option key="DSP">DSP</option>
                            {dspList.map((item: string) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}                        
                        </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                        <Form.Select name="exchange" className="fsz-875rem" onChange={e=>setExchange(e.target.value)} defaultValue={exchange}  >
                          <option key="Exchange">Exchange</option>
                            {["General", "GoogleAdx", 'Yandex RU'].map((item: string) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}                        
                        </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                        <Form.Select name="addOns" className="fsz-875rem" onChange={e=>setAddOns(e.target.value)} defaultValue={addOns}  >
                          <option key="Add-Ons">Add-Ons</option>
                            {["No", "UA", 'Timer'].map((item: string) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}                        
                        </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className={style.campaign_input}>
                        <Form.Select name="type" className="fsz-875rem" style={{ borderRadius: "0.375rem" }} onChange={e=>setType(e.target.value)} defaultValue={type} >
                            <option key="Type">Type</option>
                            {["Image", "Video"].map((item: any) => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                  </Col>
                  {/* {<Col>
                    <Form.Group>
                      <Form.Select  name="env" className="fsz-875rem" onChange={e=>setEnv(e.target.value)} defaultValue={env} >
                          <option key="Environment">Environment</option>
                          {["MobileWeb", "InApp"].map((item: string) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>} */}
              </Col>
              <Col lg={6} style={{ display: "flex", justifyContent: "end" }} className="order-12" >
                <Button onClick={() => handleNewTagBtnClick()} variant="primary" style={{ margin: "0" }} >
                  Create New Tag
                </Button>
              </Col>
        </Card.Header>
      </>
    );
}

export default TopFilter;